var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.source),function(line){return _c(_vm.tag,{key:line,tag:"component",domProps:{"innerHTML":_vm._s(line)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }